import { colors } from './colors'

export const button = {
  main: {
    background: {
      default: colors('link'),
      disabled: colors('foreground', 0.15)
    },
    border: {
      default: 'transparent',
      disabled: colors('foreground', 0.25)
    },
    text: {
      default: colors('background'),
      disabled: colors('foreground', 0.25)
    },
    hover: colors('link', 0.5),
    radius: '0'
  }
}

export default { button, colors }
